import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {articleMarketplaceModalName} from "./configs/article-marketplace-config";
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {ArticleMarketplaceData, ArticleMarketplaceDialogData} from "../../../types/marketplace.types";
import {MatFormField, MatInput} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatLabel} from "@angular/material/form-field";
import {MatTooltip} from "@angular/material/tooltip";
import {ProductCardService} from "../../../services/product-card.service";
import {ArticleMarketplaceModalService} from "./services/article-marketplace-modal.service";
import {ArticleMarketplaceStateService} from "../../../services-state/article-marketplace-state.service";

@Component({
  selector: 'app-article-marketplace-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    MatFormField,
    FormsModule,
    MatInput,
    MatLabel,
    MatTooltip
  ],
  templateUrl: './article-marketplace-modal.component.html',
  styleUrl: './article-marketplace-modal.component.scss'
})
export class ArticleMarketplaceModalComponent extends BaseModalComponent {
  private articleMarketplaceDialogData = inject<ArticleMarketplaceDialogData>(MAT_DIALOG_DATA);
  private productCardService: ProductCardService = inject(ProductCardService);
  private articleMarketplaceModalService: ArticleMarketplaceModalService = inject(ArticleMarketplaceModalService);
  private articleMarketplaceStateService: ArticleMarketplaceStateService = inject(ArticleMarketplaceStateService);

  public searchValue: string = '';
  private marketplace: string = '';

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(articleMarketplaceModalName);
    this.marketplace = this.articleMarketplaceDialogData.marketplace;
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(articleMarketplaceModalName);
  }

  public filterArticles(): Array<ArticleMarketplaceData> {
    return this.articleMarketplaceModalService.filterArticles({
      searchValue: this.searchValue,
      articleMarketplaceData: this.articleMarketplaceStateService.articleMarketplacesState()[this.marketplace]
    });
  }

  public async handleDetach(id: number): Promise<void> {
    if (!id) {
      this.errorService.showErrorMessage('Id не существует!')
      return;
    }

    const detachProductCard = {
      marketplace: this.articleMarketplaceDialogData.marketplace,
      queryParams: { articleId: id }
    };

    await this.productCardService.detachProductCard(detachProductCard)
      .then(() => this.removeArticleMarketplaceItem(id));
  }

  private removeArticleMarketplaceItem(id: number): void {
    this.articleMarketplaceStateService.removeArticleMarketplaceItem({
      marketplace: this.articleMarketplaceDialogData.marketplace,
      id: id
    });
  }
}
